import React from 'react'
// import { STYLES, COLORS } from 'x/config/styles'

import XIcon from './XIcon'

const BackIcon = (props) => <XIcon name='arrow-back' {...props} />

export default BackIcon
